'use client';

import { captureException, logger } from '@sentry/nextjs';
import { useEffect } from 'react';

export default function HubError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error(error.message, { area: 'hub', digest: error.digest });
    captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 px-6 text-center">
      <h1 className="hub-display text-4xl text-cream">The takeover hit a snag</h1>
      <p className="max-w-sm text-[17px] text-cream/70">
        Something went wrong loading the hub. Give it another go.
      </p>
      <button
        type="button"
        onClick={reset}
        className="hub-label min-h-[48px] border border-cream/40 px-6 text-cream transition-colors hover:bg-cream/10"
      >
        Try again
      </button>
      <a
        href="https://www.aeo.eu"
        className="hub-label-sm text-cream/50 underline underline-offset-4"
      >
        Go to AEO.EU
      </a>
    </div>
  );
}
